var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgINsvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 23,
    viewBox: "0 0 21 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVG",
    clipPath: "url(#clip0_3778_71)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M20.675 21.4871C19.4355 21.4576 18.2256 21.4576 16.9862 21.4871C16.7206 21.4871 16.6616 21.4281 16.6616 21.1625C16.6616 18.9787 16.6616 16.7654 16.6616 14.5816C16.6616 14.08 16.6321 13.5783 16.4845 13.1061C16.0418 11.5716 14.2712 11.0109 13.0023 12.0438C12.3235 12.5749 12.0579 13.3128 12.0579 14.198C12.0579 16.2637 12.0579 18.3295 12.0579 20.3951C12.0579 20.6607 12.0284 20.9264 12.0579 21.2214C12.0874 21.4576 11.9695 21.5165 11.7628 21.4871C10.4939 21.4871 9.25444 21.4871 7.98553 21.4871C7.74945 21.4871 7.69043 21.4281 7.69043 21.192C7.71994 19.3328 7.71994 17.4737 7.71994 15.585C7.71994 13.2832 7.71994 10.9814 7.69043 8.7091C7.69043 8.44351 7.74945 8.38449 7.98553 8.38449C9.25444 8.38449 10.4939 8.38449 11.7628 8.38449C11.999 8.38449 12.0579 8.44351 12.0579 8.67959C12.0579 9.15176 12.0579 9.62392 12.0579 10.1846C12.1465 10.0961 12.176 10.0666 12.2055 10.0371C13.3564 8.35498 14.9795 7.88281 16.8976 8.17792C19.1109 8.53204 20.5274 10.0666 20.8815 12.4274C20.9701 12.9881 20.9996 13.5488 20.9996 14.1095C20.9996 16.4703 20.9996 18.8016 20.9996 21.1625C20.9996 21.3986 20.9406 21.4871 20.675 21.4871Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M5.3302 14.9341C5.3302 16.9998 5.3302 19.0656 5.3302 21.1312C5.3302 21.3968 5.27118 21.4854 5.00559 21.4854C3.76615 21.4559 2.52672 21.4854 1.28728 21.4854C1.05121 21.4854 0.992188 21.4263 0.992188 21.1903C0.992188 17.0293 0.992188 12.8389 0.992188 8.67792C0.992188 8.47134 1.05121 8.38281 1.28728 8.38281C2.55623 8.38281 3.82517 8.38281 5.09412 8.38281C5.35971 8.38281 5.38922 8.47134 5.38922 8.70743C5.3302 10.7731 5.3302 12.8389 5.3302 14.9341Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M5.53717 4.96035C5.24207 6.14076 4.03215 6.8195 2.64516 6.58342C1.16965 6.34733 0.343354 4.90133 0.874539 3.48483C1.22867 2.59953 2.08446 2.06834 3.17634 2.09785C4.82892 2.06834 5.9208 3.3963 5.53717 4.96035Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3778_71"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 22,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgINsvg);
export default __webpack_public_path__ + "static/media/INsvg.ce3a50659f6b5f66ba98f70e912ce1ea.svg";
export { ForwardRef as ReactComponent };